export const defaultSelectedLeadership = () => {
	return {
		leadership: null,
		users_list: [],
        user_id: null
	}
}

export default {
	leaderships: [],
    users: [],
	sellers: [],
    action: 'create',
    selectedLeadership: defaultSelectedLeadership(),
	params: {
		paginate: true,
		page: 1,
		perPage: 15,
		filter: '',
		sortBy: 'leadership',
		sort: 'ASC'
	}
}



// WEBPACK FOOTER //
// ./src/modules/leadership/state.js